import React from "react";

import {CircularProgress} from "@material-ui/core";
import CheckOutlinedIcon from "@material-ui/icons/CheckOutlined";
import ErrorIcon from "@material-ui/icons/Error";

import {DataAssetOverview} from "common/flowmaster/types/data_asset";

function getStatusIcon(info: DataAssetOverview["info"]) {
  return info.is_complete ? (
    <CheckOutlinedIcon style={{color: "green"}} />
  ) : info.has_failed ? (
    <ErrorIcon style={{color: "red"}} />
  ) : (
    <CircularProgress
      size={20}
      style={{color: info.has_errors ? "red" : undefined}}
    />
  );
}

export default getStatusIcon;
